import PropTypes from "prop-types";

import isEmpty from "../../../validation/is-empty";
import { translate } from "../../../utils/translation";

/// props validation | SQ(javascript:S6774)
FileInput.propTypes = {
  setFile: PropTypes.func,
};
export function FileInput(props) {
  const { setFile } = props;

  return (
    <label className="general-modal-button">
      <input
        type="file"
        accept=".xlsx"
        onChange={(e) => {
          if (e.target.files && e.target.files.length > 0) {
            setFile(e.target.files[0]);
          }
        }}
      />
      {translate("Attach File")}
    </label>
  );
}
/// props validation | SQ(javascript:S6774)
FileTray.propTypes = {
  file: PropTypes.object,
};
export function FileTray(props) {
  const { file } = props;
  let fileName = "No File Added";

  if (!isEmpty(file)) {
    fileName = file[0].name;
  }

  return (
    <div className="pcu-file-display">
      <b>File:</b> {fileName}
    </div>
  );
}
/// props validation | SQ(javascript:S6774)
DisplayError.propTypes = {
  error: PropTypes.object,
};
export function DisplayError(props) {
  const { error } = props;
  if (isEmpty(error)) {
    return null;
  }
  return (
    <div className="feedback-error-container">
      <div className={error.type}>
        <b>{error.text}</b>
      </div>
    </div>
  );
}
